import styles from './Checkbox.module.scss';

interface CheckboxProps {
  id: string;
  value: boolean;
  label: React.ReactNode;
  setValue: (val: boolean) => void;
  error?: string;
}

const Checkbox = ({ id, value, label, setValue, error = '' }: CheckboxProps) => {
  return (
    <div className={styles.wrapper}>
      <input
        type="checkbox"
        className={styles.checkbox}
        checked={value}
        onChange={(e) => setValue(e.target.checked)}
        id={id}
        name={id}
      />
      <label className={styles.label} htmlFor={id} />
      <div>
        {label}
        {error && <div className={styles.errorText}>{error}</div>}
      </div>
    </div>
  );
};

export default Checkbox;
